/* ============================================
   BAWLAA THEME — MAIN JS
   Uses Shopify Cart API (no Storefront API needed)
   ============================================ */

(function() {
  'use strict';

  const esc = v => String(v == null ? '' : v).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

  // ── CART STATE ──────────────────────────────
  let cartData = { items: [], total_price: 0, item_count: 0 };

  // ── CART DRAWER ──────────────────────────────
  const cartTrigger = document.getElementById('cart-trigger');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartClose = document.getElementById('cart-close');
  const checkoutBtn = document.getElementById('checkout-btn');

  function openCart() {
    cartDrawer.classList.add('open');
    cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCart() {
    cartDrawer.classList.remove('open');
    cartOverlay.classList.remove('open');
    const mobileNavOpen = document.getElementById('mobile-nav-drawer')?.classList.contains('open');
    if (!mobileNavOpen) document.body.style.overflow = '';
  }

  if (cartTrigger) cartTrigger.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // Expose for product page
  window.openCart = openCart;

  // ── FETCH CART ──────────────────────────────
  async function refreshCart() {
    try {
      const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js');
      if (!res.ok) throw new Error('Unable to refresh cart');
      cartData = await res.json();
      renderCart();
      updateCartCount(cartData.item_count);
    } catch(e) {
      console.error('Cart fetch error:', e);
    }
  }

  window.refreshCart = refreshCart;

  function renderCart() {
    const body = document.getElementById('cart-body');
    const total = document.getElementById('cart-total');
    const drawerCount = document.getElementById('drawer-count');

    if (!body) return;

    drawerCount && (drawerCount.textContent = cartData.item_count);
    total && (total.textContent = '₹' + Math.round(cartData.total_price / 100));
    checkoutBtn && (checkoutBtn.disabled = cartData.item_count === 0);

    if (!cartData.items || cartData.items.length === 0) {
      body.innerHTML = '<div class="cart-drawer__empty"><span>Your cart is empty</span></div>';
      return;
    }

    body.innerHTML = cartData.items.map(item => `
      <div class="cart-item">
        <div class="cart-item__img">
          ${item.image ? `<img src="${esc(item.image)}" alt="${esc(item.product_title)}">` : ''}
        </div>
        <div>
          <p class="cart-item__name">${esc(item.product_title)}</p>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p style="font-family:var(--head);font-size:0.58rem;color:var(--muted);margin-top:2px;">${esc(item.variant_title)}</p>` : ''}
          <p class="cart-item__price">₹${Math.round(item.final_price / 100)} × ${item.quantity}</p>
          <button class="cart-item__remove" data-key="${esc(item.key)}">Remove</button>
        </div>
      </div>
    `).join('');
  }

  document.getElementById('cart-body')?.addEventListener('click', e => {
    const btn = e.target.closest('.cart-item__remove');
    if (btn) removeCartItem(btn.dataset.key);
  });

  function updateCartCount(count) {
    document.querySelectorAll('#cart-count').forEach(el => el.textContent = count);
  }

  // ── REMOVE ITEM ──────────────────────────────
  window.removeCartItem = async function(key) {
    try {
      const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      if (!res.ok) throw new Error('Unable to remove item');
      await refreshCart();
    } catch(e) {
      showToast('Unable to remove item. Please try again.');
      console.error('Remove error:', e);
    }
  };

  // ── CHECKOUT ──────────────────────────────
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', () => {
      window.location.href = (window.Shopify?.routes?.root || '/') + 'checkout';
    });
  }

  // ── TOAST ──────────────────────────────
  function showToast(msg) {
    const toast = document.getElementById('bawlaa-toast');
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 2500);
  }

  // ── INIT ──────────────────────────────
  refreshCart();

  // ── MOBILE NAV DRAWER ──────────────────
  const hamburger     = document.getElementById('nav-hamburger');
  const mobileOverlay = document.getElementById('mobile-nav-overlay');
  const mobileDrawer  = document.getElementById('mobile-nav-drawer');
  const mobileClose   = document.getElementById('mobile-nav-close');

  function openMobileNav() {
    hamburger && hamburger.classList.add('open');
    hamburger && hamburger.setAttribute('aria-expanded', 'true');
    mobileOverlay && mobileOverlay.classList.add('open');
    mobileDrawer && mobileDrawer.classList.add('open');
    mobileDrawer && mobileDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    hamburger && hamburger.classList.remove('open');
    hamburger && hamburger.setAttribute('aria-expanded', 'false');
    mobileOverlay && mobileOverlay.classList.remove('open');
    mobileDrawer && mobileDrawer.classList.remove('open');
    mobileDrawer && mobileDrawer.setAttribute('aria-hidden', 'true');
    const cartOpen = document.getElementById('cart-drawer')?.classList.contains('open');
    if (!cartOpen) document.body.style.overflow = '';
  }

  if (hamburger)     hamburger.addEventListener('click', openMobileNav);
  if (mobileClose)   mobileClose.addEventListener('click', closeMobileNav);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileNav);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && mobileDrawer && mobileDrawer.classList.contains('open')) {
      closeMobileNav();
    }
  });

})();
